<template>
  <v-layout>
    <v-layout row wrap>
      <v-flex class="mt-5" xs12 sm12 md12 lg8 offset-lg2>
      <v-carousel :cycle="false" v-if="showCarousel" v-model="actualItem" :light="true" hide-delimiters :key="questionnaireItems.length">
        <v-carousel-item v-for="item in questionnaireItems" v-bind:src="''" :key="item.itemOrder"
        reverse-transition="" transition="">
          <v-flex style="margin-left: 10%; margin-right: 10%">
          <v-card>
            <v-flex class="ma-4 pa-1">
            <v-card >
              <v-card-title>
                <v-icon class="pl-1" v-if="isRecommended(item.itemId)" color="primary" >star</v-icon>
                <span style="margin-left: auto; margin-right: 0;">
                  <v-btn small flat v-on:click="showScope(findItemById(items, item.itemId).scope)">
                    <span>
                      {{ $t('info.scopes.SCOPE'+findItemById(items, item.itemId).scope+'.TITLE', questionnaire.version) }}
                    </span>
                    <v-icon right light small>info_outline</v-icon>
                  </v-btn>
                </span>
              </v-card-title>
              <v-card-title class="title" v-t="{path: 'ITEM'+item.itemId+'.TITLE', locale: questionnaire.version}">
              </v-card-title>
              <v-card-title>
                <span>
                  <h5>
                    <v-icon color="deep-purple lighten-4" v-if="findItemById(items, item.itemId).complexity == 1">radio_button_checked</v-icon>
                    <v-icon color="deep-purple lighten-4" v-else>radio_button_unchecked</v-icon>
                    <v-icon color="deep-purple lighten-1" v-if="findItemById(items, item.itemId).complexity == 2">radio_button_checked</v-icon>
                    <v-icon color="deep-purple lighten-1" v-else>radio_button_unchecked</v-icon>
                    <v-icon color="deep-purple darken-4" v-if="findItemById(items, item.itemId).complexity == 3">radio_button_checked</v-icon>
                    <v-icon color="deep-purple darken-4" v-else>radio_button_unchecked</v-icon>
                  </h5>
                </span>
                <span class="subheading" style="margin-left: auto; margin-right: 0; cursor: pointer">
                  <v-icon v-on:click="showHelp(item.itemId)">info_outline</v-icon>
                </span>
              </v-card-title>
            </v-card>
            </v-flex>


            <v-card-actions class="text-xs-center" style="display: block" v-if="item.erasable && !item.erasableAnswered">
              <v-card-text v-t="{path: 'info.fiveGreens.BODY', locale: questionnaire.version}"></v-card-text>
              <v-card-actions>
                <v-btn class="blue--text darken-1" flat @click.native="eraseItem(item.itemId)">
                  <span v-t="{path: 'info.fiveGreens.ERASE_BUTTON', locale: questionnaire.version}"></span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn class="blue--text darken-1" flat @click.native="keepItem(item.itemId)">
                  <span v-t="{path: 'info.fiveGreens.KEEP_BUTTON', locale: questionnaire.version}"></span>
                </v-btn>
              </v-card-actions>
            </v-card-actions>
            <v-card-actions class="text-xs-center" style="display: block" v-else>
              <v-btn class="green--text pl-5 pr-5" :disabled="!canBeAnswered(item.itemId)" @click.native="saveAnswer(item.itemId, 3)" v-if="!item.answered">
                <span class="headline"><v-icon color="green">sentiment_very_satisfied</v-icon></span>
              </v-btn>
              <v-btn class="orange--text pl-5 pr-5" @click.native="saveAnswer(item.itemId, 2)" v-if="!item.answered">
                <span class="headline"><v-icon color="orange">sentiment_satisfied</v-icon></span>
              </v-btn>
              <v-btn class="red--text pl-5 pr-5" @click.native="saveAnswer(item.itemId, 1)" v-if="!item.answered">
                <span class="headline"><v-icon color="red">sentiment_very_dissatisfied</v-icon></span>
              </v-btn>

              <v-btn class="headline pl-5 pr-5" flat @click.native="" v-if="item.answered" :disabled="item.answer != 3"
                     ><v-icon color="green">sentiment_very_satisfied</v-icon>
              </v-btn>
              <v-btn class="headline pl-5 pr-5" flat @click.native="" v-if="item.answered" :disabled="item.answer != 2"
                     ><v-icon color="orange">sentiment_satisfied</v-icon>
              </v-btn>
              <v-btn class="headline pl-5 pr-5" flat @click.native="" v-if="item.answered"  :disabled="item.answer != 1"
                     ><v-icon color="red">sentiment_very_dissatisfied</v-icon>
              </v-btn>
              <v-btn icon v-if="item.answered && !questionnaire.completed" @click.native="undoAnswer(item.itemId)"><v-icon>lock_open</v-icon></v-btn>
            </v-card-actions>
            <v-card-title>
              <v-btn large color="primary" block v-on:click="showIncorporate(item.itemId)">
                <span v-t="{path: 'info.incorporateDialog.BUTTON', locale: questionnaire.version}"></span>
                <v-icon light small right>live_help</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          </v-flex>
        </v-carousel-item>
      </v-carousel>
      </v-flex>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <div class="text-xs-center">
          <v-pagination :length="this.questionnaireItems.length" v-model="paginationItem" circle
                        v-on:input="computePaginationColors()" v-on:next="computePaginationColors()" v-on:previous="computePaginationColors()"></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showFinalSummary" lazy transition="dialog-bottom-transition" fullscreen persistent>
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ $t('questionnaire.completed.TITLE') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!--<v-card-title class="headline">{{ $t('questionnaire.completed.TITLE') }}</v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-layout>
            <v-btn class="blue--text darken-1" @click.native="showSummary = false">{{ $t('forms.BACK') }}</v-btn>
            <evaloe-results :questionnaire="this.questionnaire" :questionnaireItems="this.questionnaireItems"></evaloe-results>
            <v-btn class="blue--text darken-1" @click.native="nextScreen">{{ $t('forms.CONTINUE') }}</v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-btn fab large bottom right fixed class="success" v-show="complete" v-on:click="showSummary=true"><v-icon>grid_on</v-icon></v-btn>

    <v-dialog v-model="dialogHelp" lazy scrollable max-width="70%">
      <v-card>
        <v-divider></v-divider>

        <v-card-text>
          <span class="large-span" v-html="$t('ITEM'+this.dialogKey+'.ITEM_EXPLANATION', locale = questionnaire.version)"></span>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="dialogHelp = false">
            <span>{{$t('questionnaire.itemHelpDialog.CLOSE_BUTTON')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="scopeHelp" lazy scrollable max-width="50%">
      <v-card>
        <v-card-title class="headline" v-t="{path: 'info.scopes.SCOPE'+this.scopeKey+'.TITLE', locale: questionnaire.version}"></v-card-title>
        <v-divider></v-divider>

        <v-card-text class="large-span" v-html="$t('info.scopes.SCOPE'+this.scopeKey+'.EXPLANATION', questionnaire.version)">
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="scopeHelp = false">
            <span v-html="$t('questionnaire.itemHelpDialog.CLOSE_BUTTON', questionnaire.version)"></span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="firstItemAssessment" lazy transition="dialog-bottom-transition" max-width="50%">
      <v-card>
        <v-card-text>{{$t('questionnaire.firstItem.BODY')}}</v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="firstItemAssessment = false">
            <span class="large-span">{{$t('questionnaire.firstItem.OK')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="firstSelfAssessment" lazy transition="dialog-bottom-transition" max-width="50%">
      <v-card>
        <v-card-text class="large-span">{{$t('questionnaire.firstItem.BODY')}}</v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="firstSelfAssessment = false">
            <span>{{$t('questionnaire.firstItem.OK')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="checkItemHelp" lazy transition="dialog-bottom-transition" max-width="50%">
      <v-card>
        <v-card-text class="large-span">{{$t('questionnaire.checkHelpFirstDialog.BODY')}}</v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="checkItemHelp = false">
            <span>{{$t('questionnaire.checkHelpFirstDialog.CLOSE_BUTTON')}}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <evaloe-assist :questionnaire-items="this.questionnaireItems"
                   :version="this.questionnaire.version"
                   :incorporateHelp="this.incorporateHelp"
                   :incorporateKey="this.incorporateKey"
                   v-on:close="closeAssist"
    ></evaloe-assist>

  </v-layout>
</template>
<style>
.answered-item:not(.v-pagination__item--active) {
  background-color: lightgray !important;
}
.large-span {
  font-size: large;
}
</style>
<script>
  import {ItemResource} from '../../api/item'
  import {QuestionnaireResource} from '../../api/questionnaire'
  import EvaloeResults from './EvaloeResults.vue'
  import EvaloeAssist from './EvaloeAssist.vue'

  export default {
    name: 'questionnaire',
    components: {
      'evaloe-results': EvaloeResults,
      'evaloe-assist': EvaloeAssist
    },
    data () {
      return {
        dialogQuest: false,
        loadingQuest: false,
        checkedQuest: false,
        popups: [],
        items: [],
        actualItem: 0,
        paginationItem: 1,
        questionnaireItems: [],
        showCarousel: false,
        cycle: false,
        item: {},
        dialogCompletedQuestionnaire: false,
        dialogKey: 30,
        dialogHelp: false,
        incorporateKey: 30,
        incorporateHelp: false,
        scopeKey: 5,
        scopeHelp: false,
        questionnaire: {},
        incorporateSection: 'text',
        previousRecommended: [],
        showSummary: true,
        firstSelfAssessment: false,
        firstItemAssessment: false,
        currentItemid: null,
        currentAnswer: null,
        erasableItems: [],
        checkItemHelp: false,
        checkedHelps: []
      }
    },
    beforeRouteEnter: function (to, from, next) {
      var qi = []
      QuestionnaireResource().getResponses({id: to.params.questionnaireId}).then(response => {
        qi = response.body
        next(vm => {
          vm.questionnaireItems = qi
        })
      }, response => {
        next(vm => {
          vm.$emit('showSnackbar', response.body.message)
          vm.$router.push({name: 'Questionnaires'})
        })
      })
    },
    created: function () {
      ItemResource().get().then(response => {
        this.items = response.body
      }, response => {
        console.log(response)
      })
      QuestionnaireResource().get({id: this.$route.params.questionnaireId}).then(response => {
        this.questionnaire = response.body
        if (this.$auth.check('TEACHER') && this.questionnaire.teacherId !== this.$auth.user().id) {
          this.$emit('showSnackbar', 'FORBIDDEN_ACCESS')
          this.$router.push({name: 'Questionnaires'})
        }
        this.firstSelfAssessment = this.questionnaire.order === 1
      }, response => {
        this.$emit('showSnackbar', response.body.message)
        console.log('error' + response.body)
      })
      QuestionnaireResource().getPreviousRecommended({id: this.$route.params.questionnaireId}).then(response => {
        this.previousRecommended = response.body
      }, response => {
        console.log('err' + response.body)
      })
      QuestionnaireResource().getErasableItems({id: this.$route.params.questionnaireId}).then(response => {
        this.erasableItems = response.body
        this.questionnaireItems.forEach(item => {
          let currentItem = this.findErasableItem(item.itemId)
          if (currentItem) {
            item.erasable = true
            item.erasableAnswered = currentItem.answered
          } else {
            item.erasable = false
            item.erasableAnswered = false
          }
        })
      }, response => {
        console.log('error')
        console.log(response.body)
      })
    },
    mounted: function () {
      this.dialogCompletedQuestionnaire = this.completedQuestionnaire()
      setTimeout(this.computePaginationColors, 100)
    },
    watch: {
      questionnaireItems: function () {
        this.showCarousel = false
        this.$nextTick(() => (this.showCarousel = true))
        this.showCarousel = true
      },
      paginationItem: function () {
        this.actualItem = this.paginationItem - 1
        this.firstItemAssessment = this.firstTimeAnsweringItem(this.actualItem)
        this.computePaginationColors()
      },
      actualItem: function () {
        this.paginationItem = this.actualItem + 1
        this.firstItemAssessment = this.firstTimeAnsweringItem(this.actualItem)
        // console.log(this.actualItem)
      }
    },
    computed: {
      complete: function () {
        return this.completedQuestionnaire()
      },
      showFinalSummary: function () {
        return this.showSummary && this.complete
      }
    },
    methods: {
      computePaginationColors: function () {
        this.$nextTick(function () {
          const answeredItems = []
          this.questionnaireItems.forEach(function (item, index) {
            if (item.answered) {
              answeredItems.push((index + 1).toString())
            }
          })
          const buttons = document.getElementsByClassName('v-pagination__item')
          for (const button of buttons) {
            if (answeredItems.includes(button.innerHTML)) {
              button.classList.add('answered-item')
            }
          }
        })
      },
      findItemById: function (collection, itemId) {
        return this._.find(collection, function (i) {
          return i.id === itemId
        })
      },
      firstTimeAnsweringItem: function (item) {
        if (this.questionnaire.order === 1) return false
        if (this.questionnaireItems[item].answered) return false
        return !this.canBeAnswered(this.questionnaireItems[item].itemId)
      },
      canBeAnswered: function (item) {
        switch (this.questionnaire.order) {
          case 1:
            return false
          case 2:
            return [5, 6, 11, 12, 15, 19, 20, 21, 22, 23, 26, 27, 28, 29, 30].includes(item)
          case 3:
            return [4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 18, 19, 20, 21, 22, 23, 25, 26, 27, 28, 29, 30].includes(item)
          case 4:
            return [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30].includes(item)
          case 5:
            return [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30].includes(item)
          default:
            return true
        }
      },
      findItemByName: function (collection, itemName) {
        return this._.find(collection, function (i) {
          return i.name === itemName
        })
      },
      findQuestionnaireItem: function (itemId) {
        return this._.find(this.questionnaireItems, function (i) {
          return i.itemId === itemId
        })
      },
      findErasableItem: function (itemId) {
        return this._.find(this.erasableItems, function (i) {
          return i.itemId === itemId
        })
      },
      firstUnansweredItem: function () {
        return this.questionnaireItems.findIndex(function (item) {
          console.log(item)
          return !item.answered
        })
      },
      saveAnswer: function (itemId, answer) {
        if (!this.itemHelpChecked(itemId)) {
          this.checkItemHelp = true
        } else {
          const questionnaireId = this.$route.params.questionnaireId
          const currentItem = this.findQuestionnaireItem(itemId)
          currentItem.answer = answer
          QuestionnaireResource().putResponse({
            questionnaireId: questionnaireId,
            itemId: itemId
          }, currentItem).then(_ => {
            this.findQuestionnaireItem(itemId).answered = true
            this.findQuestionnaireItem(itemId).answer = answer
            this.dialogCompletedQuestionnaire = this.completedQuestionnaire()
            this.nextItem()
          }, response => {
            this.$emit('showSnackbar', response.body.message)
            console.log(response)
          })
        }
      },
      itemHelpChecked: function (itemId) {
        return this.checkedHelps.includes(itemId)
      },
      undoAnswer: function (itemId) {
        const questionnaireId = this.$route.params.questionnaireId
        const currentItem = this.findQuestionnaireItem(itemId)
        QuestionnaireResource().undo({questionnaireId: questionnaireId, itemId: itemId}, currentItem).then(_ => {
          this.findQuestionnaireItem(itemId).answered = false
          this.findQuestionnaireItem(itemId).answer = null
          this.dialogCompletedQuestionnaire = this.completedQuestionnaire()
        }, response => {
          this.$emit('showSnackbar', response.body.message)
          console.log(response)
        })
      },
      eraseItem: function (itemId) {
        const questionnaireId = this.$route.params.questionnaireId
        const currentItem = this.findQuestionnaireItem(itemId)
        // let currentIndex = this.actualItem
        console.log(this.actualItem)
        QuestionnaireResource().deleteItem({questionnaireId: questionnaireId, itemId: itemId}, {}).then(_ => {
          let index = this.questionnaireItems.indexOf(currentItem)
          if (index > -1) this.questionnaireItems.splice(index, 1)
          if (index === this.questionnaireItems.length) this.actualItem--
        }, response => {
          console.log(response)
        })
      },
      keepItem: function (itemId) {
        const questionnaireId = this.$route.params.questionnaireId
        QuestionnaireResource().keepItem({questionnaireId: questionnaireId, itemId: itemId}, {}).then(_ => {
          this.findQuestionnaireItem(itemId).erasable = false
          this.actualItem = this.actualItem - 1
          this.actualItem = this.actualItem + 1
        }, response => {
          console.log(response)
        })
      },
      nextItem: function () {
        if (this.actualItem === this.questionnaireItems.length - 1) {
          const next = this.firstUnansweredItem()
          console.log(next)
          if (next !== -1) this.actualItem = next
        } else {
          this.actualItem = this.actualItem + 1
        }
        this.computePaginationColors()
      },
      showHelp: function (itemId) {
        this.dialogKey = itemId
        this.dialogHelp = true
      },
      showIncorporate: function (itemId) {
        if (!this.checkedHelps.includes(itemId)) this.checkedHelps.push(itemId)
        this.incorporateKey = itemId
        this.incorporateHelp = true
      },
      showScope: function (scopeId) {
        this.scopeKey = scopeId
        this.scopeHelp = true
      },
      completedQuestionnaire: function () {
        if (this.questionnaireItems.length > 0) {
          for (const item of this.questionnaireItems) {
            if (item.answered === false) {
              return false
            }
          }
          return true
        }
      },
      isRecommended: function (itemId) {
        for (const item of this.previousRecommended) {
          if (item.chosen && item.itemId === itemId) return true
        }
        return false
      },
      closeAssist: function () {
        this.incorporateHelp = false
      },
      nextScreen: function () {
        QuestionnaireResource().finish({id: this.$route.params.questionnaireId}, {}).then(_ => {
          if (this.$auth.check('EXPERT')) {
            this.$router.push({name: 'Questionnaires'})
          } else {
            this.$router.push({name: 'Recommendations', params: {questionnaireId: this.$route.params.questionnaireId}})
          }
        }, _ => {
          if (this.questionnaire.completed) {
            if (this.$auth.check('EXPERT')) {
              this.$router.push({name: 'Questionnaires'})
            } else {
              this.$router.push({name: 'Recommendations', params: {questionnaireId: this.$route.params.questionnaireId}})
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/questionnaires/Questionnaire.vue